import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/my-players")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
